import { AES, Utf8, Hex, mode } from "jscrypto";

// Define types for better type checking
type CipherText = string;

// Key and IV setup (16 bytes each for AES-128)
const secretKey = Utf8.parse("12345678901234567890123456789012");
const iv = Utf8.parse("1234567890123456");

// Encrypt function
export function get_encrypted_value(text: string): CipherText {
  const encrypted = AES.encrypt(text, secretKey, {
    iv: iv,
    mode: mode.CBC,
  });

  return encrypted.cipherText!.toString(Hex);
}

// Decrypt function
export function get_decrypted_value(data: string): string {
  const decrypted = AES.decrypt(
    {
      cipherText: Hex.parse(data),
    } as any,
    secretKey,
    {
      iv: iv,
      mode: mode.CBC,
    }
  );
  return Utf8.stringify(decrypted);
}
